<template>
  <div v-if="socials.length" class="s-footer-socials">
    <SButtonIcon
      v-for="platform in socials"
      :key="platform"
      :aria-label="platform"
      class="s-footer-socials__icon"
      :href="socialUrls[platform]"
      :icon="`fa-brands fa-${platform}`"
      target="_blank"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { LocaleMorpheus } from "@solvari/translations";

import { SButtonIcon } from "@solvari/common-fe";
import { useI18nMainSiteLayout } from "@solvari/translations";
import { getEnv } from "@solvari/utils";

type FooterSocialPlatform = "facebook" | "instagram" | "linkedin" | "youtube";

const socialsByLocale: Record<LocaleMorpheus, FooterSocialPlatform[]> = {
  "nl-NL": ["facebook", "instagram", "youtube", "linkedin"],
  "be-NL": ["facebook", "instagram", "youtube", "linkedin"],
  "be-FR": ["facebook"],
  "fr-FR": [],
  "dk-DA": [],
  "se-SV": [],
};

const { tr } = useI18nMainSiteLayout();

const socials = socialsByLocale[getEnv().config.localeCode];

const socialUrls = computed<Record<FooterSocialPlatform, string>>(() => ({
  facebook: tr("main_site.layout.footer_social_facebook_url"),
  instagram: tr("main_site.layout.footer_social_instagram_url"),
  youtube: tr("main_site.layout.footer_social_youtube_url"),
  linkedin: tr("main_site.layout.footer_social_linkedin_url"),
}));
</script>

<style lang="postcss">
.s-footer-socials {
  @apply flex items-center gap-2;

  &__icon {
    @apply text-white;
  }
}
</style>
